import { render } from "./MergeAgencies.vue?vue&type=template&id=2caae5ea&scoped=true"
import script from "./MergeAgencies.vue?vue&type=script&lang=js"
export * from "./MergeAgencies.vue?vue&type=script&lang=js"

import "./MergeAgencies.vue?vue&type=style&index=0&id=2caae5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caae5ea"]])

export default __exports__